import { render, staticRenderFns } from "./MenuDropdown.vue?vue&type=template&id=29229dc4"
import script from "./MenuDropdown.vue?vue&type=script&lang=js"
export * from "./MenuDropdown.vue?vue&type=script&lang=js"
import style0 from "./MenuDropdown.vue?vue&type=style&index=0&id=29229dc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports